"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceType = void 0;
/**
 * The type of a service.
 */
var ServiceType;
(function (ServiceType) {
    /**
     * Not explicitly configured.
     */
    ServiceType[ServiceType["INVALID_AUTHENTICATION"] = 0] = "INVALID_AUTHENTICATION";
    /**
     * Admin service.
     */
    ServiceType[ServiceType["ADMIN"] = 1] = "ADMIN";
    /**
     * Public authenticated service.
     */
    ServiceType[ServiceType["PUBLIC"] = 2] = "PUBLIC";
    /**
     * Public unauthenticated service.
     */
    ServiceType[ServiceType["UNAUTHENTICATED"] = 3] = "UNAUTHENTICATED";
    /**
     * Internal service.
     */
    ServiceType[ServiceType["INTERNAL"] = 4] = "INTERNAL";
    ServiceType[ServiceType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ServiceType || (exports.ServiceType = ServiceType = {}));
//# sourceMappingURL=RpcServiceInfo.js.map